import React, { useContext } from 'react';
import { ThemeContext } from '../../context/theme/ThemeContext';

function Index(props) {
    const { theme, changeTheme } = useContext(ThemeContext);
    const { text } = props;
    return (
        <h4 className={"sm black bold my-3"}>{text}</h4>
    );
}

export default Index;